import { ConfirmationDialog } from '@fortem-monorepo/react-ui'

import { useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'
import { useRemoveInstrumentMutation } from '@/pages/instruments/market-summary/market-summary.mutations'

export interface RemoveInstrumentDialogProps {
  open: boolean
  onClose: () => void
  mutationParams: { instrument_id: number }
}

export const RemoveInstrumentDialog = ({ open, onClose, mutationParams }: RemoveInstrumentDialogProps) => {
  const { instrumentsQuery, hasWriteAccess } = useMarketSummaryContext()
  const instrument = instrumentsQuery.data?.find((row) => row.instrument_id === mutationParams.instrument_id)
  const mutation = useRemoveInstrumentMutation()

  return (
    <ConfirmationDialog
      open={open}
      title="Remove Instrument"
      description="This removes the instrument from Market Summary and every display."
      pending={mutation.isPending}
      valid={hasWriteAccess}
      onClose={() => {
        if (!mutation.isPending) onClose()
      }}
      action={() => {
        if (!hasWriteAccess || mutation.isPending) return
        mutation.mutate(mutationParams, { onSuccess: onClose })
      }}
    >
      <p className="text-sm">
        Instrument {mutationParams.instrument_id}
        {instrument ? ` · ${instrument.section}` : ''}
      </p>
    </ConfirmationDialog>
  )
}
